import styled, {css} from 'styled-components'

export const StyledMailerHistoryTab = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 24px;
    overflow-y: auto;
`

export const StyledMailerHistoryToolbar = styled.div(
    ({theme: {spacing}}) => css`
        display: flex;
        align-items: center;
        gap: ${spacing * 2}px;
    `
)

export const StyledCountsCluster = styled.div(
    ({theme: {spacing}}) => css`
        display: flex;
        align-items: center;
        gap: ${spacing * 1.5}px;
        flex-wrap: wrap;
    `
)

export const StyledTriggeredByCell = styled.span(
    ({theme: {palette}}) => css`
        color: ${palette.neutral[700]};

        &.unknown {
            color: ${palette.neutral[500]};
            font-style: italic;
        }
    `
)

export const StyledMailerHistoryErrorBox = styled.div(
    ({theme: {palette, spacing}}) => css`
        display: flex;
        align-items: center;
        justify-content: center;
        padding: ${spacing * 8}px ${spacing * 4}px;
        color: ${palette.danger[600]};
    `
)
